import { SeriesLabel } from "./series-label";

/** What every series in the card shares — the card's heading. The legend carries what varies. */
export function PanelMetricBadge({
    unitCategory,
    deviceName,
}: {
    unitCategory: string | null;
    deviceName: string | null;
}) {
    if (!unitCategory && !deviceName) return null;

    return (
        // self-center: one line centers on the unit picker, two lines start level with its top.
        <div className={"flex min-w-0 flex-wrap items-baseline gap-x-[8px] self-center"}>
            <SeriesLabel deviceName={deviceName} unitCategory={unitCategory} variant={"badge"} />
        </div>
    );
}
